var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "214px",
    height: "127px",
    viewBox: "0 0 214 127",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hidden") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phase-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hidden",
    transform: "translate(0.569849, 0.732051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.930151,0.267949192 C142.2125,0.267949192 176.993074,19.3555548 210.271872,57.5307661 C212.828628,60.4637054 212.897064,64.7971614 210.472346,67.8054155 L210.290478,68.0231271 L209.299022,69.1622968 C176.563691,106.566065 142.107401,125.267949 105.930151,125.267949 C69.37989,125.267949 34.71334,106.17842 1.93050115,67.9993604 C-0.589105648,65.0650137 -0.641535522,60.7618348 1.76842308,57.7709 L1.94915595,57.5544319 L2.94057234,56.4144335 C35.6733432,18.983444 70.0032028,0.267949192 105.930151,0.267949192 Z M106.138184,10.2407996 C76.5879501,10.2407996 46.933182,25.6220694 17.1738798,56.3846088 L16.2720487,57.3215131 C13.3379367,60.3849583 13.3050027,65.2059862 16.196988,68.3092315 C44.5840146,98.7699345 74.5644133,114.000286 106.138184,114.000286 C137.408185,114.000286 166.949379,99.0615855 194.761765,69.1841844 L195.604036,68.2742364 C198.451547,65.1805201 198.41819,60.4104693 195.527692,57.3568786 C165.794616,25.9461593 135.998113,10.2407996 106.138184,10.2407996 Z M105.930151,18.2679492 C130.506822,18.2679492 150.430151,38.1912778 150.430151,62.7679492 C150.430151,87.3446206 130.506822,107.267949 105.930151,107.267949 C81.3534797,107.267949 61.430151,87.3446206 61.430151,62.7679492 C61.430151,38.1912778 81.3534797,18.2679492 105.930151,18.2679492 Z",
    id: "Combined-Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(104.335596, 63.147114) rotate(60.000000) translate(-104.335596, -63.147114) ",
    x: 91.3355956,
    y: -26.3528857,
    width: 26,
    height: 179,
    rx: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    transform: "translate(104.214761, 63.000000) rotate(60.000000) translate(-104.214761, -63.000000) ",
    x: 99.2147607,
    y: -44,
    width: 10,
    height: 214,
    rx: 5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidden);
export default __webpack_public_path__ + "static/media/hidden.d3514c7ff5abcaec8341f1fcf33658b4.svg";
export { ForwardRef as ReactComponent };